import { Card, Switch, Form, Typography } from "antd";

const { Text } = Typography;

export default function MenuSection({ config, onChange }) {
  const menu = config.menu;

  const update = (key, value) => {
    onChange({
      ...config,
      menu: {
        ...menu,
        [key]: value
      }
    });
  };

  return (
    <Card bordered={false}>
      <Form layout="vertical">

        <Form.Item label="Show Menu on Booking Page">
          <Switch
            checked={menu.enabled}
            onChange={(v) => update("enabled", v)}
          />
          <Text type="secondary">
            Displays your restaurant menu below the booking section.
          </Text>
        </Form.Item>

        <Form.Item label="Show Prices">
          <Switch
            checked={menu.showPrices}
            onChange={(v) => update("showPrices", v)}
            disabled={!menu.enabled}
          />
          <Text type="secondary">
            Toggle menu pricing visibility.
          </Text>
        </Form.Item>

      </Form>
    </Card>
  );
}
